export default __webpack_public_path__ + "static/media/BLK-BNB.69459259.svg";